module.exports = __webpack_public_path__ + "img/151845075_477256573684381_5969966435854375124_n.ccb72615.jpg";